import { useCallback, useEffect, useState } from 'react'

import { loadState, saveState } from 'utility/localStorage'

export const useLocalStorage = (key, defaultValue) => {
  const [isHydrated, setIsHydrated] = useState(false)
  const [value, setValueClassic] = useState(defaultValue)

  // Stable identity so consumers can safely list setValue in effect deps
  const setValue = useCallback(
    (newValue) => {
      saveState(key, newValue)
      setValueClassic(newValue)
    },
    [key],
  )

  useEffect(() => {
    const stored = loadState(key)
    setValueClassic(stored === undefined ? defaultValue : stored)
    setIsHydrated(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])

  return [value, setValue, isHydrated]
}
